import { createReducer } from 'redux-starter-kit';
import i18next from 'i18next';

import { ParentOrganizationsApi } from './ParentOrganizationsApi';
import { handleError } from '../../../modules/utils/handleError';
import * as Dict from '../../../modules/utils/Dict';

export const parentOrganizationsModule = 'parentOrganizations';
const LOADING = `${parentOrganizationsModule}/LOADING`;
const TABLE_DATA = `${parentOrganizationsModule}/TABLE_DATA`;
const CLEAR_STATE = `${parentOrganizationsModule}/CLEAR_STATE`;

/**
 * Reducer
 */

const initialState = {
  loading: false,
  tableData: {
    content: [],
    totalElements: 0
  }
};

export default createReducer(initialState, {
  [LOADING]: (state, action) => {
    state.loading = action.payload;
  },
  [TABLE_DATA]: (state, action) => {
    const filter = action.filter || {};
    if (filter.pageNumber && filter.pageNumber !== 1) {
      state.tableData.content = [...state.tableData.content, ...action.payload.content];
    } else {
      state.tableData = action.payload;
    }
  },
  [CLEAR_STATE]: () => initialState
});

/**
 * Actions
 */

export const loadParentOrg = filter => async (dispatch) => {
  try {
    dispatch({ type: LOADING, payload: true });
    const filterString = JSON.stringify({ ...filter, typeCode: '01' });
    const { data } = await ParentOrganizationsApi.loadTableData(filterString);
    if (data.result && data.result.content) {
      for (let row of data.result.content) {
        row.providerLocation = await Dict.item('60', row.location);
      }
      dispatch({
        type: TABLE_DATA,
        payload: data.result,
        filter
      });
    } else {
      handleError(data, i18next.t('serviceProviders_errorLoadTable'));
    }
  } catch (error) {
    handleError(error, i18next.t('serviceProviders_errorLoadTable'));
  } finally {
    dispatch({ type: LOADING, payload: false });
  }
};

export const clearState = () => ({ type: CLEAR_STATE });
